import React from 'react';
import {Card} from "../../../../components/card/card.jsx";
import DutyDispatchGauge from "./duty-dispatch-gauge.jsx";
import DutyBarGraph from "./duty-bar-graph.jsx";
import DutyDispatchEngage from "./duty-dispatch-engage.jsx";
import DashCard from "./dash-card.jsx";
import {useLoaderData} from "react-router";
import MetricDashCard from "../../../../components/dash-card/metric-dash-card.jsx";

const DutyDispatchCard = ({ graphData, countersData }) => {
    const loaderData = useLoaderData();

    return (
        <Card className={"dash-main-card col-span-3"}>
            <Card.Header className={"border-b-0! bg-transparent"}>
                <Card.Title className={"bg-transparent text-white text-center w-full text-(length:--font-lg)! translate-y-1.5"}>Despachos</Card.Title>
            </Card.Header>

            <Card.Body className={"flex-1 min-h-0 grid grid-cols-12 gap-(--dash-gap-md) px-(--dash-pad-md)! pb-(--dash-pad-md)!"}>
                <DashCard className={"min-h-0 col-span-4"}>
                    <DutyDispatchGauge
                        dispatch={countersData.dispatch}
                        dispatchSource={graphData.dispatchSource}
                    />
                </DashCard>

                <DashCard className={"min-h-0 col-span-4 grid grid-cols-1 grid-rows-5 gap-(--dash-gap-sm)"}>
                    <div className={"row-span-2"}>
                        <DutyDispatchEngage
                            data={graphData.availableAndEngageTime.averageTime}
                        />
                    </div>
                    <div className={"row-span-3"}>
                        <DutyBarGraph
                            data={graphData.dispatchNature}
                            title={"Naturezas em despacho"}
                        />
                    </div>
                </DashCard>

                <DashCard className={"min-h-0 col-span-4 grid grid-cols-2 grid-rows-2 gap-(--dash-gap-md) p-(--dash-pad-lg)!"}>
                    <MetricDashCard
                        counterCard
                        title="Abordagens"
                        value={countersData?.encounter || 0}
                        width={136}
                        height={116}
                        dashClassName="place-self-center text-center"
                        pClassName="leading-tight"
                    />
                    <MetricDashCard
                        counterCard
                        title={loaderData?.bo_name}
                        value={countersData?.bos || 0}
                        width={136}
                        height={116}
                        dashClassName="place-self-center text-center"
                        pClassName="leading-tight"
                    />
                    <MetricDashCard
                        counterCard
                        title="Apreensões"
                        value={countersData?.apprehensions || 0}
                        width={136}
                        height={116}
                        dashClassName="place-self-center text-center"
                        pClassName="leading-tight"
                    />
                    <MetricDashCard
                        counterCard
                        title="Guarnições em atividade"
                        value={countersData?.activities || 0}
                        width={136}
                        height={116}
                        dashClassName="place-self-center text-center"
                        pClassName="leading-tight"
                    />
                </DashCard>
            </Card.Body>
        </Card>
    );
};

export default React.memo(DutyDispatchCard);
